export default __webpack_public_path__ + "static/media/pantry1-afterF-480w.914f9248.png";